import { FC, useContext } from "react";

import { FormType } from "@simplyk/common";

import { useFormV2Context } from "../../../../contexts/FormV2Context";

import { useTicketingFirstStepSubmit } from "./useTicketingFirstStepSubmit";

import { HeartsAnimationContext } from "@/canvas/features/FormV2/contexts/heartsAnimationContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { HeartsFormButton } from "@/forms-design-system/HeartsFormButton";
import { ArrowRight } from "@/icons/outlined";

export type TicketingCheckoutFooterProps = {
  totalTickets: number;
  hasDonation: boolean;
};

export const TicketingCheckoutFooter: FC<TicketingCheckoutFooterProps> = ({ totalTickets, hasDonation }) => {
  const { t } = useTranslate();
  const { isMembership } = useFormV2Context(FormType.Ticketing);
  const { onFirstStepSubmit, canSubmitFirstStep } = useTicketingFirstStepSubmit();
  const { shouldDisplayHeartsAnimation, animationKey } = useContext(HeartsAnimationContext);

  const label =
    totalTickets > 0
      ? isMembership
        ? t("ticketing", "checkout")
        : t("ticketing", "checkoutWithCount", { count: totalTickets })
      : hasDonation
        ? t("ticketing", "donate")
        : t("ticketing", "checkout");

  return (
    <HeartsFormButton
      type="submit"
      endIcon={<ArrowRight />}
      onClick={onFirstStepSubmit}
      disabled={!canSubmitFirstStep}
      data-test="form-v2-step1-submit-button"
      animated={shouldDisplayHeartsAnimation}
      animationKey={animationKey}
      autoplay
      sx={() => ({
        boxShadow: "0px 16px 32px 0px rgba(0, 0, 0, 0.12)",
      })}
    >
      {label}
    </HeartsFormButton>
  );
};
